import React, {Component} from 'react';
import {Table} from 'reactstrap';
import {toast} from 'react-toastify';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';

import {getPermission, getUser} from '../../utils/TokenManager';
import ErrorMsg from "../common/ErrorMsg";
import {downloadPDF, DAILY_ACTIVITY_REPORT} from "../common/Constants"
import KPIService from "../../services/KPIService";
import DailyActivityService from "../../services/DailyActivityService";
import loadingGIF from "../../public/assets/images/loading.gif";
import LoadingModal from "../common/LoadingModal";


export default class DailyActivity extends Component {
    state = {
        userList: [],
        // all kpi list
        kpiList: [],
        // kpi available in select box to select
        selectableKpiList: [],
        // kpi data / achievement data list return by api
        kpiDataList: [],
        startDate: "",
        endDate: "",
        // kpi list which are currently shown
        selected7Kpi: [],
        kpiDataObj: {},
        isLoading: false,
        totalObj: {},
        // previously saved selected Kpi list object
        selectedKpiObj: {},
        showGIF: false
    };

    auth = {
		user: getUser(),
		permission: getPermission()[DAILY_ACTIVITY_REPORT]
	}

    componentDidMount = () => {
        if (this.props.agencyLocation) {
            this.getInitialState();
            this.getUserList();
        }
    };

    getInitialState = async () => {
        if (this.auth.permission.can_view) {
            try {
                let currentDate = moment().format("YYYY-MM-DD");
                let result = await KPIService.getKPIFilteredBYDate(
                    this.props.agencyLocation, currentDate, currentDate
                );
                if (200 === result.status) {
                    let kpiList = result.data.map(kpi => ({...kpi}));
                    this.setState({kpiList});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
            }
            try {
                let result = await DailyActivityService.getSelectedKpiList(
                    this.props.agencyLocation
                );
                if (200 === result.status) {
                    let selectedKpiObj = {...result.data};
                    let selectedKpiList = [...selectedKpiObj.kpi_list];
                    let kpiList = this.state.kpiList.map(kpi => ({...kpi}));
                    
                    let selected7Kpi = [];
                    selectedKpiList.map(kpiId => {
                        for (let index in kpiList) {
                            if (kpiList[index].id === kpiId && !(kpiList[index]['selected'])) {
                                selected7Kpi.push({...kpiList[index]});
                                kpiList[index]['selected'] = true;
                            }
                        }
                    });
                    
                    let noOfSelected7Kpi = selected7Kpi.length;
                    let noOfRemainingKpi = 7 - noOfSelected7Kpi;
                    let i = 0;
                    for (let index in kpiList) {
                        if (i >= noOfRemainingKpi) {
                            break;
                        }
                        if (!(kpiList[index]['selected'])) {
                            selected7Kpi.push({...kpiList[index]});
                            kpiList[index]['selected'] = true;
                            i++;
                        }
                    }
        
                    this.setState({selectedKpiObj, selected7Kpi}, () => {
                        this.getKpiListExceptSelected();
                        this.getAll7KPIData();
                    });
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>);
            }
        }
    };

    getUserList = async () => {
        if (this.auth.permission.can_view) {
            this.setState({showGIF: true});
            try {
                let result = await DailyActivityService.getUserList(this.props.agencyLocation);
                if (200 === result.status) {
                    let userList = result.data.user.map(user => ({...user}));
                    this.setState({userList});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
            }
            this.setState({showGIF: false});
        }
    }

    getAllFilteredKpi = async () => {
        if (this.auth.permission.can_view) {
            const {agencyLocation} = this.props;
            const {startDate, endDate} = this.state;
            let newStartDate = moment(startDate).format("YYYY-MM-DD");
            let newEndDate = moment(endDate).format("YYYY-MM-DD");
            try {
                let result = await KPIService.getKPIFilteredBYDate(
                    agencyLocation, newStartDate, newEndDate
                );
                if (200 === result.status) {
                    let kpiList = result.data.map(kpi => ({...kpi}));
                    let newKpiList = kpiList.map(kpi => ({...kpi}));
                    
                    let selected7Kpi = [];
                    this.state.selected7Kpi.map(kpi => {
                        for (let index in newKpiList) {
                            if (newKpiList[index].id === kpi.id && !(newKpiList[index]['selected'])) {
                                selected7Kpi.push({...newKpiList[index]});
                                newKpiList[index]['selected'] = true;
                            }
                        }
                    });
                    
                    let noOfSelected7Kpi = selected7Kpi.length;
                    let noOfRemainingKpi = 7 - noOfSelected7Kpi;

                    let i = 0;
                    for (let index in newKpiList) {
                        if (i >= noOfRemainingKpi) {
                            break;
                        }
                        if (!(newKpiList[index]['selected'])) {
                            selected7Kpi.push({...newKpiList[index]});
                            newKpiList[index]['selected'] = true;
                            i++;
                        }
                    }
                    
                    this.setState({kpiList, selected7Kpi}, () => {
                        this.getKpiListExceptSelected();
                        this.getAll7KPIData();
                    });
                }
            } catch (error) {
                console.log(error);
                toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
            }
        }
    }

    getKpiListExceptSelected = () => {
        let {selected7Kpi} = this.state;
        let selected7KpiId = selected7Kpi.map(kpi => {return kpi.id});
        let newKpiList = this.state.kpiList.filter(kpi => {
            if (!(selected7KpiId.includes(kpi.id))) {
                return {...kpi};
            }
        });
        this.setState({selectableKpiList: newKpiList});
    }

    getAll7KPIData = () => {
        let {selected7Kpi} = this.state;
        let selected7KpiId = selected7Kpi.map(kpi => {return kpi.id});
        this.getKpiData(selected7KpiId);
    };

    getKpiData = async (kpiList) => {
        if (kpiList.length) {
            const {agencyLocation} = this.props;
            const {startDate, endDate} = this.state;
            let newStartDate = moment(startDate).format("YYYY-MM-DD");
            let newEndDate = moment(endDate).format("YYYY-MM-DD");
            try {
                let result = await DailyActivityService.getKpiData(agencyLocation, kpiList, newStartDate, newEndDate);
                if (200 === result.status) {
                    let kpiDataList = result.data.map(kpiData => ({...kpiData}));
                    let kpiDataObj = kpiList.length === 7 ? {} : {...this.state.kpiDataObj};
                    let key = '';
                    kpiDataList.map(kpiData => {
                        key = kpiData.user + "_" + kpiData.kpi_list; 
                        kpiDataObj[key] = kpiData.total;
                    });
                    let totalObj = {}, count = 0;
                    let {userList, selected7Kpi} = this.state;
                    userList.map((user) => {
                        selected7Kpi.map((kpi) => {
                            key = user.id + "_" + kpi.id;
                            count = key in kpiDataObj ? kpiDataObj[key] : 0;
                            totalObj[kpi.id] = kpi.id in totalObj ? totalObj[kpi.id] + count : count;
                        });
                    });
                    this.setState({kpiDataList, kpiDataObj, totalObj});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
            }
        } else {

        }
    }

    filterKPIData = (isFiltered) => {
        if (!isFiltered) {
            this.setState({
                startDate: "",
                endDate: ""
            }, () => {
                this.getAllFilteredKpi();
            });
        } else {
            let startDate = this.state.startDate;
            let endDate = this.state.endDate;
            if(!startDate || typeof startDate === "undefined" || (startDate === "Invalid date")) {
                startDate = moment();
            }
            if (!endDate || typeof endDate === "undefined" || endDate === "Invalid date") {
                endDate = moment();
            }
            this.setState({startDate, endDate}, () => {
                this.getAllFilteredKpi();
            });
        }
    };

    handleDateChange = (date, field) => {
        if (field === "startDate") {
            let startDate = moment(date);
            let {endDate} = this.state;
            let minDate = moment(startDate);
            if (!(endDate >= minDate)) {
                this.setState({endDate: minDate});
            }
            this.setState({startDate: date});
        } else {
            this.setState({endDate: date});
        }
        
    };

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    };

    handleSelectKPI = (e, kpiId) => {
        // kpiId = prev kpi id to be replaced
        // value = new kpi id selected
        let value = parseInt(e.target.value);
        let selectedKpi;
        this.state.selectableKpiList.map(kpi => {
            if(kpi.id === value) {
                selectedKpi = {...kpi};
            }
        });
        let selected7Kpi = this.state.selected7Kpi.map(kpi => {
            if (kpiId === kpi.id) {
                return {...selectedKpi};
            }
            return {...kpi};
        });
        this.setState({selected7Kpi}, () => {
            this.getKpiListExceptSelected();
            this.getKpiData([value]);
            this.saveSelection();
        });

    }

    generatePDF = async() => {
        if (this.auth.permission.can_view) {
            const {selected7Kpi, userList, kpiDataObj, totalObj} = this.state;
            this.setState({isLoading: true});
            try {
                let startDate = this.state.startDate;
                let endDate = this.state.endDate;
                let newStartDate = '', newEndDate = '';
                if(startDate && typeof startDate !== "undefined" && startDate !== "Invalid date") {
                    newStartDate = moment(startDate).format("YYYY-MM-DD");
                } 
                if (endDate && typeof endDate !== "undefined" && endDate !== "Invalid date") {
                    newEndDate = moment(endDate).format("YYYY-MM-DD");
                }

                let data = {
                    kpi_list: selected7Kpi,
                    user_list: userList,
                    kpi_data: kpiDataObj,
                    data_total: totalObj,
                    start_date: newStartDate,
                    end_date: newEndDate
                }

                let result = await DailyActivityService.getPDF(this.props.agencyLocation, data);
                
                if (200 === result.status) {
                    let content = result.data.content;
                    let fileName = result.data.file_name;
                    downloadPDF(content, fileName);
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>);
            }
            this.setState({isLoading: false});
        }
    }

    saveSelection = async () => {
        if (this.auth.permission.can_edit) {
            try {
                const {agencyLocation} = this.props;
                let {selected7Kpi} = this.state;
                let selected7KpiId = selected7Kpi.map(kpi => {return kpi.id});
                let selectedKpiObj = {
                    agency_location: agencyLocation,
                    kpi_list: selected7KpiId
                }
                let result = await DailyActivityService.putSelectedKpiList(
                    agencyLocation, selectedKpiObj
                );
                if (200 === result.status) {
                }
            } catch (error) {
                console.log("In Unmount: ", error, error.response);
            }
        }
    }

    componentWillUnmount = async () => {
        await this.saveSelection();
    }

    render() {
        const {
            kpiDataObj, userList, selectableKpiList, selected7Kpi, 
            startDate, endDate, totalObj, showGIF
        } = this.state;
        let headings = [], headingsTotal = [], rows = [], key = '', count, countFormat;

        userList.map((user, index) => {
            let cols = [];
            cols.push(<td key={'user' + user.id}>{user.full_name}</td>);
            selected7Kpi.map((kpi, ind) => {
                key = user.id + "_" + kpi.id;
                count = key in kpiDataObj ? kpiDataObj[key] : 0;
                if (kpi.data_type === "Currency") {
                    countFormat = <NumberFormat key={index} 
                    value={count} displayType={'text'} thousandSeparator={true} decimalScale={2} prefix={'$ '} />;
                } else if (kpi.data_type === "Percentage") {
                    countFormat = <NumberFormat key={index} 
                    value={count} displayType={'text'} thousandSeparator={true} decimalScale={2} suffix={' %'} />;
                } else {
                    countFormat = <NumberFormat key={index} 
                    value={count} displayType={'text'} thousandSeparator={true} decimalScale={0} />;
                }
                cols.push(
                    <td className="text-center" key={key + ind}>{countFormat}</td>
                );
            });
            rows.push(<tr key={index}>{cols}</tr>);
        });

        let kpiOptions = [], totalFormat, total;
        selectableKpiList.map((kpi, index) => {
            kpiOptions.push(<option key={index} value={kpi.id}>{kpi.name}</option>);
        });

        headings.push(<th key={-1} rowSpan={2} className="font-weight-bold staff-td-width">Staff Name</th>);
        selected7Kpi.map((kpi, index) => {
            headings.push(
                <th className="daily-activity-th" key={index}>
                    {kpi.name}
                    <select name="kpi" className="daily-activity-select" onChange={(e) => this.handleSelectKPI(e, kpi.id)} value={kpi.id}>
                        <option value={kpi.id} disabled>-------Select-------</option>
                        {kpiOptions}
                    </select>
                </th>
                );
            total = kpi.id in totalObj ? totalObj[kpi.id] : 0;
            if (kpi.data_type === "Currency") {
                totalFormat = <NumberFormat key={index} 
                value={total} displayType={'text'} thousandSeparator={true} decimalScale={2} prefix={'$ '} />;
            } else if (kpi.data_type === "Percentage") {
                totalFormat = <NumberFormat key={index} 
                value={total} displayType={'text'} thousandSeparator={true} decimalScale={2} suffix={' %'} />;
            } else {
                totalFormat = <NumberFormat key={index} 
                value={total} displayType={'text'} thousandSeparator={true} decimalScale={0} />;
            }
            headingsTotal.push(          
                <th className="text-center font-weight-bold" key={index}>{totalFormat}</th>
            );
        });
        
        return (
            this.auth.permission.can_view ?
            <div className="tab-pane" role="tabpanel">
                <div className="row mb-1">
                    <div className="col-md-3 pr-0">
                        <label className="mb-0 pt-1">Top 7 KPI Activity For - &nbsp;</label>
                        {moment().format("MM/DD/YYYY")}
                    </div>
                    <div className="col-md-2 pr-0">
                        <DatePicker
                            selected={startDate} onChangeRaw={this.handleDateChangeRaw}
                            onChange={(event) => this.handleDateChange(event, "startDate")}
                            dateFormat="MM/DD/YYYY" fixedHeight
                            showMonthDropdown showYearDropdown
                            dropdownMode="select" className="form-control form-control-sm"
                            placeholderText="Start date"
                            minDate={moment('2012-01-01')}
                            maxDate={moment().add(5, 'years')}
                            autoComplete="off" list="autocompleteOff" 
                        />
                    </div>
                    <div className="col-md-2 pr-0">
                        <DatePicker
                            selected={endDate} onChangeRaw={this.handleDateChangeRaw}
                            onChange={(event) => this.handleDateChange(event, "endDate")}
                            fixedHeight dateFormat="MM/DD/YYYY"
                            showMonthDropdown showYearDropdown
                            dropdownMode="select" className="form-control form-control-sm"
                            placeholderText="End date"
                            minDate={moment(startDate).add(1, 'days')}
                            autoComplete="off" list="autocompleteOff" 
                        />
                    </div>
                    <div className="col-md-3 pr-2">
                        <button className="btn btn-success btn-sm" onClick={() => this.filterKPIData(true)}>Filter by Date</button>
                        &nbsp; &nbsp;
                        <button className="btn btn-warning btn-sm" onClick={() => this.filterKPIData(false)}>Clear Filter</button>
                    </div>
                    <div className="col-md-2">
                        <ul className="secondary-menu">
                            <li onClick={() => this.getAll7KPIData()} title="Reload list" className="float-right pt-1">
                                <a className="text-info pr-0"> <span className="fa fa-refresh"></span></a>
                            </li>
                            <li onClick={this.generatePDF} className="float-right pt-1">
                                <a className="text-info pr-3 mr-0"> Print Report</a>
                            </li>
                        </ul>
                    </div>
                </div>
                
                <Table responsive striped bordered size="sm" className="mb-0">
                    <thead className="bg-light">
                        <tr>{headings}</tr>
                        <tr className="bg-warning">{headingsTotal}</tr>
                    </thead>
                    <tbody>
                        {
                            rows.length > 0 ? 
                                rows 
                            : showGIF && <p className="text-center">
                                <img src={loadingGIF} alt="loading" width="32" height="32" />
                            </p>
                        }
                    </tbody>
                </Table>
                {this.state.isLoading && <LoadingModal modal={this.state.isLoading} />}
            </div>
            : <div className="tab-pane text-center" role="tabpanel">
                Access Denied
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/dailyActivityReport/DailyActivity.js